// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles-module--heading--3hHZo","fadeIn":"styles-module--fadeIn--2xprQ","pulse":"styles-module--pulse--3Set6","slideInDown":"styles-module--slideInDown--1jHnl"};